<div class="custom-portal"><ng-container #viewContainer /></div>
<div [style.display]="'flex'">
  <aside style="height: calc(100vh - 48px); top: 0 !important;" [tuiNavigationAside]="expandedSettings()" tuiTheme="theme"
    class="invert-color">
    <header>
      <button tuiAsideItem type="button" [tuiSkeleton]="loadingParking()">
        <span>Settings</span>
      </button>
    </header>



    <!-- Dynamic settings navigation items based on user role -->
    <ng-container *ngIf="navigationItems && navigationItems.length > 0">
      <ng-container *ngFor="let item of navigationItems">
        <!-- Regular navigation item without children -->
        <a *ngIf="item && !item.children && hasAccess(item)" tuiAsideItem
          [ngClass]="{ 'active_route': isRouteActive(item.route) }" [routerLink]="getDynamicRoute(item.route)"
          style="cursor: pointer;" [tuiSkeleton]="loadingParking()">
          <img [src]="getRoleSpecificIcon(item)" [alt]="item?.label || 'Navigation'" [tuiSkeleton]="loadingParking()">
          {{ getRoleSpecificLabel(item) }}
        </a>

        <!-- NEW: Navigation item with children (expanded, no dropdown) -->
        <ng-container *ngIf="item && item.children && hasAccess(item)">
          <app-input-heading [heading]="getRoleSpecificLabel(item)" [tuiSkeleton]="loadingParking()" [skeleton]="loadingParking()" />
          <ng-container *ngFor="let child of item.children">
            <a tuiAsideItem *ngIf="child && hasAccess(child)" [ngClass]="{ 'active_route': isRouteActive(child.route) }"
              [routerLink]="getDynamicRoute(child.route)" class="btn-margin" style="cursor: pointer;"
              [tuiSkeleton]="loadingParking()">
              <img [src]="getRoleSpecificIcon(child)" [alt]="child?.label || 'Navigation'"
                [tuiSkeleton]="loadingParking()">
              {{ getRoleSpecificLabel(child) }}
            </a>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  </aside>

  <main tuiNavigationMain [style.border]="'0px!important'">
    <router-outlet></router-outlet>
  </main>
</div>